<template>
	<a class="action-button" :class="direction" @click="action"><slot>Back</slot></a>
</template>

<script>
export default {
	props: {
		action: {
			type: Function,
			required: true,
		},
		direction: {
			type: String,
			default: "left",
		},
	},
};
</script>

<style lang="scss" scoped>
	.action-button {
		cursor: pointer;
		position: absolute;
		top: 5vh;
		z-index: 10;
		font-size: 22px;
		text-transform: uppercase;
		font-weight: 700;
		line-height: 1;
		letter-spacing: .03em;

		&.left {
			left: 5vw;

			&:before {
				content: "\25C4";
				display: inline-block;
				margin-right: .5em;
			}
		}

		&.right {
			right: 5vw;

			&:after {
				content: "\25BA";
				display: inline-block;
				margin-left: .5em;
			}
		}
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/ArrowButton.vue